import React, {useEffect} from 'react';
import * as S from './RegisterFail.styles';

import {logPageLoadEvents} from '@ibibo/analytics';

const RegesterFail = () => {

    useEffect(() => {
        logPageLoadEvents('leadform:errorscreen', {});
    }, []);

    return(
        <S.ErrorMsgWrap>
                <S.ErrorCircleWrap>
                    <S.Exclamation>!</S.Exclamation>
                </S.ErrorCircleWrap>
            <S.ErrorMsgText>You have already submitted your request earlier.</S.ErrorMsgText>
            <S.InfoText>Thank you for showing interest again.</S.InfoText>
        </S.ErrorMsgWrap> 
    );
}

export default RegesterFail;